import { render, staticRenderFns } from "./OrcamentoSideBar.vue?vue&type=template&id=5ad4adfd&scoped=true"
import script from "./OrcamentoSideBar.vue?vue&type=script&lang=js"
export * from "./OrcamentoSideBar.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoSideBar.vue?vue&type=style&index=0&id=5ad4adfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4adfd",
  null
  
)

export default component.exports